import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type {
  GetDocumentsResponse,
  DocumentDto,
  GetDocumentsRequest,
  CreateDocumentResponse,
  GetDocumentResponse,
  GetDocumentRequest,
  DeleteDocumentRequest,
} from "./types";
import { baseQueryCreator } from "redux/baseQuery";
import env from "env";

const { documentRepositoryService } = env.api.baseUrl;

const baseQuery = fetchBaseQuery({
  baseUrl: documentRepositoryService,
  prepareHeaders: (headers, { getState }: any) => {
    const token = getState().auth.accessToken;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const documentApi = createApi({
  reducerPath: "documentApi",
  baseQuery: baseQueryCreator(baseQuery),
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    getDocuments: builder.query<GetDocumentsResponse, GetDocumentsRequest>({
      query: (params) => ({
        url: "documents",
        params: {
          ...params,
        },
      }),
    }),
    createDocument: builder.mutation<CreateDocumentResponse, DocumentDto>({
      query: ({ orgToken, ...patch }) => ({
        url: "documents",
        method: "POST",
        body: patch,
        headers: {
          "org-token": orgToken,
        },
      }),
    }),
    getDocument: builder.mutation<GetDocumentResponse, GetDocumentRequest>({
      query: ({ documentId, orgToken, ...params }) => ({
        url: `documents/${documentId}`,
        params,
        headers: {
          "org-token": orgToken,
        },
      }),
    }),
    deleteDocument: builder.mutation<
      GetDocumentResponse,
      DeleteDocumentRequest
    >({
      query: ({ documentId, orgToken }) => ({
        url: `documents/${documentId}`,
        method: "DELETE",
        headers: {
          "org-token": orgToken,
        },
      }),
    }),
  }),
});

export const {
  useGetDocumentsQuery,
  useCreateDocumentMutation,
  useGetDocumentMutation,
  useDeleteDocumentMutation,
} = documentApi;
